import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import Papa from "papaparse";
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Toast } from "primereact/toast";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Card, DropdownButton, Form, Modal, Nav, NavDropdown, OverlayTrigger, Tab, Tooltip } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillCalendarWeekFill } from "react-icons/bs";
import { CiFilter } from "react-icons/ci";
import { FaArrowCircleDown } from "react-icons/fa";
import { HiChartPie } from "react-icons/hi";
import { IoIosCloseCircle, IoMdTrash } from "react-icons/io";
import { IoClose, IoDocumentTextOutline, IoPauseOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import { MdReport } from "react-icons/md";
import { SlOptionsVertical, SlUser } from "react-icons/sl";
import Loader from "react-js-loader";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Sample_CSV_format from "../../Assets/Sample_CSV_format.csv";
import { API_URL, JOB_STATUS_CLOSED, JOB_STATUS_ON_HOLD, JOB_STATUS_OPEN, allowedResumeTypes, capitalizeFirstLetter, commonDateFormat, extractDocText, extractPdfText, getAuthUserFromSessionStorage, resumeFileTypeErrorMessage } from "../../common/constant";
import { EMPLOYER_SUB_ADMIN, EMPLOYER_SUPER_ADMIN, SUB_ADMIN, SUPER_ADMIN } from "../../common/roles";
import HeaderScreen from "../HeaderScreen/HeaderScreen";
import "./DashboardScreen.css";
import { EmbedPDF } from '@simplepdf/react-embed-pdf';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const DashboardScreen = () => {
    const navigate = useNavigate();

    const [userDetails, setUserType] = useState(getAuthUserFromSessionStorage());
    const [jobList, setJobList] = useState([]);
    const [openJobList, setOpenJobList] = useState([]);
    const [closedJobList, setClosedJobList] = useState([]);
    const [onHoldJobList, setOnHoldJobList] = useState([]);

    const [allJobCount, setAllJobCount] = useState(0)
    const [openJobCount, setOpenJobCount] = useState(0)
    const [closedJobCount, setClosedJobCount] = useState(0)
    const [onHoldJobCount, setOnHoldJobCount] = useState(0)

    const [isLoading, setIsLoading] = useState(false);
    const [profileIsLoading, setProfileIsLoading] = useState(false);
    const [showJobJD, setShowJobJD] = useState(false);
    const [jobDetails, setJobDetails] = useState({});
    const [companyList, setCompanyList] = useState([]);
    const [companyUsers, setCompanyUsers] = useState([]);

    const [isRefreshing, setIsRefreshing] = useState(false);

    // Initialize selectedFields from session storage or default values
    const [selectedFields, setSelectedFields] = useState(() => {
        const savedFilters = sessionStorage.getItem('dashboardFilters');
        if (savedFilters) {
            const parsed = JSON.parse(savedFilters);
            return {
                companyId: parsed.companyId || null,
                employerSuperAdminId: parsed.employerSuperAdminId || null,
                employerSubAdminId: parsed.employerSubAdminId || null
            };
        }
        return {
            companyId: null,
            employerSuperAdminId: null,
            employerSubAdminId: null
        };
    });

    const browserResumesFileRef = useRef(null);
    const browserCSVFileRef = useRef(null);

    const [uploadedCandidateCSVFileName, setUploadedCandidateCSVFileName] = useState(null);
    const [uploadedCandidateBulkFileName, setUploadedCandidateBulkFileName] = useState(null);

    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(1);
    // when page value is same api not being called so we are using pageTrigger state here to force api call
    const [pageTrigger, setPageTrigger] = useState(0);

    const selectedFieldsRef = useRef(selectedFields);

    // Save filters to session storage whenever they change
    useEffect(() => {
        sessionStorage.setItem('dashboardFilters', JSON.stringify(selectedFields));
    }, [selectedFields]);

    // Instead, use a more controlled approach
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const hasFilters = Object.values(selectedFields).some(value => value !== null && value !== '');
            if (hasFilters) {
                resetPagination();
            }
        }, 300); // Small delay to prevent rapid API calls

        return () => clearTimeout(timeoutId);
    }, [selectedFields]);

    useEffect(() => {
        setIsLoading(true);
        const fetchAllJobs = async () => {
            try {
                const statuses = ['', JOB_STATUS_OPEN, JOB_STATUS_CLOSED, JOB_STATUS_ON_HOLD];
                for (const status of statuses) {
                    await getAllJobs(status);
                }
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching jobs:', error);
                setIsLoading(false);
            }
        };

        fetchAllJobs();

        // Load company list and users based on saved filters
        if (companyList.length === 0) {
            if (userDetails.account_type === SUB_ADMIN) {
                getRalaSubAdminCompanyList(userDetails.id)
            } else if (userDetails.account_type === SUPER_ADMIN) {
                getCompanyList()
            } else if (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "") {
                getCompanyUsers(userDetails.id)
            }
        }

        // Load company users if company is already selected
        if (selectedFields.companyId && companyUsers.length === 0) {
            getCompanyUsers(selectedFields.companyId);
        }
    }, [pageTrigger]);

    const resetPagination = () => {
        setClosedJobList([])
        setOpenJobList([])
        setOnHoldJobList([])
        setJobList([])
        setClosedJobCount(0)
        setOpenJobCount(0)
        setOnHoldJobCount(0)
        setAllJobCount(0)
        setPage(1)
        setPageTrigger((prev) => prev + 1);
    }

    // get all jobs
    const getAllJobs = async (status = '') => {
        try {
            let apiUrl = `${API_URL}api/jobs?limit=${limit}&page=${page}`;

            // Only include filter params if they have values
            let filterParams = {};
            if (selectedFields.companyId) filterParams.companyId = selectedFields.companyId;
            if (selectedFields.employerSuperAdminId) filterParams.employerSuperAdminId = selectedFields.employerSuperAdminId;
            if (selectedFields.employerSubAdminId) filterParams.employerSubAdminId = selectedFields.employerSubAdminId;

            if (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "") {
                filterParams.companyId = userDetails.id
            }

            const params = JSON.stringify({
                status: status,
                ...filterParams
            });

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userDetails.token}`,
                },
                body: params
            });
            const result = await response.json();

            // Always replace the data, don't append
            switch (status) {
                case JOB_STATUS_CLOSED:
                    setClosedJobList(result.data);
                    setClosedJobCount(result.totalCount)
                    break;
                case JOB_STATUS_OPEN:
                    setOpenJobList(result.data);
                    setOpenJobCount(result.totalCount)
                    break;
                case JOB_STATUS_ON_HOLD:
                    setOnHoldJobList(result.data);
                    setOnHoldJobCount(result.totalCount)
                    break;
                default:
                    setJobList(result.data);
                    setAllJobCount(result.totalCount)
                    break;
            }
        } catch (error) {
            resetPagination();
        }
    };

    const getCompanyList = () => {
        fetch(`${API_URL}api/getUsers?sortBy=company_name&sortOrder=asc`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            },
            body: JSON.stringify({
                account_type: EMPLOYER_SUPER_ADMIN,
                company_id: ""
            })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!_.isUndefined(response) && !_.isNull(response) && !_.isUndefined(response.data) && !_.isNull(response.data) && (response.data.length > 0)) {
                    setCompanyList(response.data);
                }
            })
            .catch((err) => {
                setCompanyList([]);
            });
    }

    const getRalaSubAdminCompanyList = (ralaSubAdminId) => {
        fetch(`${API_URL}api/getUsers?sortBy=first_name&sortOrder=asc`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            },
            body: JSON.stringify({
                account_type: EMPLOYER_SUPER_ADMIN,
                assigned_rala_sub_admin: ralaSubAdminId,
                company_id: ""
            })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!_.isUndefined(response) && !_.isNull(response) && !_.isUndefined(response.data) && !_.isNull(response.data) && !_.isEmpty(response.data) && (response.data.length > 0)) {
                    setCompanyList(response.data)
                } else {
                    setCompanyList([])
                }
            })
            .catch((err) => {
                setCompanyList([]);
            });
    }

    const openJDModal = (jobDetails) => {
        setJobDetails(jobDetails);
        setShowJobJD(true);
    }

    const [dialogHeader, setDialogHeader] = useState('');
    const [dialogShow, setDialogShow] = useState(false);
    const [dialogJobStatus, setDialogJobStatus] = useState('')
    const toast = useRef(null);

    const openJobStatusModal = (jobDetails, status, statusModalHeaderText) => {
        setJobDetails(jobDetails);
        setDialogJobStatus(status);
        setDialogHeader(statusModalHeaderText);
        setDialogShow(true);
    }

    const changeJobStatusApiCall = () => {
        setIsLoading(true)
        fetch(`${API_URL}api/changeJobStatus`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            },
            body: JSON.stringify({
                jobId: jobDetails._id,
                status: dialogJobStatus
            })
        })
            .then((response) => response.json())
            .then((response) => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: response.message, life: 3000 });
                setDialogShow(false);
                resetPagination()
            })
            .catch((err) => {
                console.log("error", err);
                setIsLoading(false)
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    }


    const [deleteJobModal, setDeleteJobModal] = useState(false);
    const [deleteJobId, setDeleteJobId] = useState(null);
    const openDeleteJobModal = (id) => {
        setDeleteJobModal(true);
        setDeleteJobId(id)
    }

    const closeDeleteJobModal = () => {
        setDeleteJobModal(false);
        setDeleteJobId(null)
    }

    const deleteJobModalfooterContent = (
        <div>
            <Button variant="primary" onClick={() => deleteJobApiCall()} >Yes</Button>
            <Button variant="outline-primary" onClick={() => closeDeleteJobModal()}>Cancel</Button>
        </div>
    );

    const deleteJobApiCall = async () => {
        setIsLoading(true)
        fetch(`${API_URL}api/deleteJob/${deleteJobId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            }
        })
            .then((response) => response.json())
            .then((response) => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: response.message, life: 3000 });
                closeDeleteJobModal();

                const statuses = ['', JOB_STATUS_OPEN, JOB_STATUS_CLOSED, JOB_STATUS_ON_HOLD];
                // Loop through the statuses and call getAllJobs for each status
                for (const status of statuses) {
                    getAllJobs(status);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("error", err);
                closeDeleteJobModal();
                setIsLoading(false)
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    }

    const statusChangeModalfooterContent = (
        <div>
            <Button variant="primary" onClick={() => changeJobStatusApiCall()} >Yes</Button>
            <Button variant="outline-primary" onClick={() => setDialogShow(false)}>Cancel</Button>
        </div>
    );

    const [errors, setErrors] = useState([]);
    const [showUploadProfiles, setShowUploadProfiles] = useState(false);
    const [candidateProfileData, setCandidateProfileData] = useState([]);

    const uploadProfileModalFooterContent = (
        <div className='row justify-content-center'>
            <div className="col-6 d-flex justify-content-center gap-2">
                <Button variant="primary" onClick={() => uploadProfileApiCall()} >Save</Button>
                <Button variant="outline-primary" onClick={() => setShowUploadProfiles(false)}>Cancel</Button>
            </div>
        </div>
    );

    const uploadCSV = (event) => {
        if (event.target.files.length > 0 && event.target.files[0].type === "text/csv") {
            setUploadedCandidateCSVFileName(event.target.files[0].name)
            Papa.parse(event.target.files[0], {
                header: true,
                skipEmptyLines: true,
                transformHeader: header => header.trim(),
                complete: function (results) {
                    if (results.data.length > 25) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Maximum 25 profile can be uploaded at once', life: 3000 });
                    }
                    else if (results.data.length === 0) {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'CSV file is empty', life: 3000 });
                    }
                    else {
                        let newInterviewerCandidateDetails = [];
                        _.map(results.data, (candidate, candidateIndex) => {
                            if (!_.isUndefined(candidate['Candidate name']) && !_.isNull(candidate['Candidate name']) && (candidate['Candidate name'] !== '')) {
                                if (candidate["available time"] != "") {
                                    const dateString = candidate["available time"];
                                    const parts = dateString.split(/[- :]/);
                                    const dateObject = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4]);
                                    if (isNaN(dateObject.getTime())) {
                                        candidate["available time"] = new Date();
                                    } else {
                                        candidate["available time"] = dateObject;
                                    }
                                } else {
                                    candidate["available time"] = new Date();
                                }
                                newInterviewerCandidateDetails.push({
                                    uniqueId: new Date().valueOf() + candidateIndex,
                                    job_id: jobDetails._id,
                                    candidate_name: candidate['Candidate name'],
                                    candidate_mobile_number: candidate["Phone number"],
                                    candidate_email: candidate["E-mail"],
                                    available_on: new Date(candidate["available time"]),
                                    resume: ""
                                });
                            }
                        })
                        if (newInterviewerCandidateDetails.length > 0)
                            setCandidateProfileData(newInterviewerCandidateDetails);
                    }
                    clearFile(browserCSVFileRef);
                },
            });
        } else {
            clearFile(browserCSVFileRef);
            setUploadedCandidateCSVFileName(null);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please upload only csv file', life: 3000 });
        }
    }

    const clearFile = (fileInput) => {
        if (fileInput.current) {
            fileInput.current.value = ''; // Reset file input
        }
    }

    const uploadFiles = async (event) => {
        const files = event.target.files;
        if (files.length > 25) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Maximum 25 profile can be uploaded at once', life: 3000 });
            clearFile(browserResumesFileRef);
            return;
        }
        if (files.length === 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one profile', life: 3000 });
            clearFile(browserResumesFileRef);
            return;
        }

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (!(allowedResumeTypes.includes(file.type))) {
                setUploadedCandidateCSVFileName(null);
                toast.current.show({ severity: 'error', summary: 'Error', detail: resumeFileTypeErrorMessage, life: 3000 });
                return false;
            }
        }

        // setCandidateProfileData([]);
        let newInterviewerCandidateDetails = [];
        setProfileIsLoading(true);
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            try {
                const [name, phone, email] =
                    "application/pdf" === file.type
                        ? await extractPdfText(file)
                        : await extractDocText(file);

                var filePath = await uploadCandidateFile(file);

                newInterviewerCandidateDetails.push({
                    uniqueId: new Date().valueOf() + i,
                    job_id: jobDetails._id,
                    candidate_name: name,
                    candidate_mobile_number: email,
                    candidate_email: phone,
                    available_on: new Date(),
                    resume: filePath
                });

            } catch (i) {
                console.error(
                    "Error processing file"
                );
            }

            setUploadedCandidateBulkFileName(file.name)
        }
        // let finalArray = candidateProfileData.concat(newInterviewerCandidateDetails)
        // setCandidateProfileData(finalArray);
        // Assuming each object in array1 and array2 has an 'email' field
        const emailSet = new Set(candidateProfileData.map(item => item.candidate_email));

        // Filter array2 to exclude objects that have the same email as in array1
        const filteredArray2 = newInterviewerCandidateDetails.filter(item => !emailSet.has(item.candidate_email));

        // Now concatenate the arrays
        const finalArray = candidateProfileData.concat(filteredArray2);
        setCandidateProfileData(finalArray);
        setProfileIsLoading(false)
        clearFile(browserResumesFileRef);
    }

    const uploadCandidateFile = async (file) => {
        try {
            const data = new FormData();
            data.append('file', file);
            const response = await fetch(`${API_URL}api/uploadFiles`, {
                method: 'POST',
                body: data
            });
            const responseData = await response.json();
            return responseData.filepath;
        } catch (error) {
            return "";
        }
    };

    const profileChangeHandler = (index, event) => {
        let newCandidateProfileData = [...candidateProfileData];
        const { name, value } = event.target;
        if (name === "candidate_mobile_number") {
            const numericInput = value.replace(/\D/g, '');
            const truncatedInput = numericInput.slice(0, 10);
            newCandidateProfileData[index][name] = truncatedInput;
            setCandidateProfileData(newCandidateProfileData);
        } else {
            newCandidateProfileData[index][event.target.name] = event.target.value;
            setCandidateProfileData(newCandidateProfileData);
        }
    };

    const changeDateHandler = (index, date) => {
        let newCandidateProfileData = [...candidateProfileData];
        newCandidateProfileData[index].available_on = date;
        setCandidateProfileData(newCandidateProfileData);
    };

    const removeCandidateProfile = (index) => {
        let newCandidateProfileData = [...candidateProfileData];
        newCandidateProfileData.splice(index, 1);
        setCandidateProfileData(newCandidateProfileData);
    }

    const uploadResumeHandler = async (index, event) => {
        if (event && event.files && event.files.length > 0) {
            setIsLoading(true)
            const file = event.files[0];
            const data = new FormData();
            data.append('file', file);
            fetch(`${API_URL}api/uploadFiles`, {
                method: 'POST',
                body: data
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status == 200) {
                        let newCandidateProfileData = [...candidateProfileData];
                        newCandidateProfileData[index].resume = response.filepath;
                        setCandidateProfileData(newCandidateProfileData);
                        toast.current.show({ severity: 'success', summary: 'Success', detail: "Resume added successfully", life: 3000 });
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    }
                    setIsLoading(false)
                })
                .catch((err) => {
                    setIsLoading(false)
                    console.log("error", err);
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: resumeFileTypeErrorMessage, life: 3000 });
        }
    };

    const getProfileErrorMessage = (uniqueId, key) => {
        const error = errors.find(err => err.key === key && err.uniqueId === uniqueId);
        return error ? error.errorMessage : null;
    }

    const validateProfileData = () => {
        const newErrors = [];
        const requiredFields = ['job_id', 'candidate_name', 'candidate_mobile_number', 'candidate_email', 'resume', 'available_on'];
        for (const obj of candidateProfileData) {
            for (const field of requiredFields) {
                const fieldLabel = capitalizeFirstLetter(field.replaceAll("_", " "));
                if (!obj.hasOwnProperty(field) || obj[field] === null || obj[field] === undefined || obj[field] === '') {
                    newErrors.push({
                        uniqueId: obj['uniqueId'],
                        key: field,
                        errorMessage: `${fieldLabel} is required!`
                    })
                } else {
                    if (field === "candidate_mobile_number" && /^\d{10}$/.test(obj[field]) === false) {
                        newErrors.push({
                            uniqueId: obj['uniqueId'],
                            key: field,
                            errorMessage: `Enter valid mobile number!`
                        })
                    }
                    if (field === "candidate_email") {
                        const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(obj[field]);
                        if (!isValid) {
                            newErrors.push({
                                uniqueId: obj['uniqueId'],
                                key: field,
                                errorMessage: `Enter valid email address!`
                            })
                        }
                    }
                }
            }
        }

        setErrors(newErrors);

        if (newErrors.length > 0) {
            return false;
        }

        const uniqueEmails = new Set();
        const uniqueMobileNumbers = new Set();
        let repeatedEntries = [];

        candidateProfileData.forEach(entry => {
            if (uniqueEmails.has(entry.candidate_email) || uniqueMobileNumbers.has(entry.candidate_mobile_number)) {
                repeatedEntries.push({
                    ...entry,
                    key: uniqueEmails.has(entry.candidate_email) ? 'candidate_email' : 'candidate_mobile_number',
                    label: uniqueEmails.has(entry.candidate_email) ? 'Candidate email' : 'Candidate mobile number'
                });
            } else {
                uniqueEmails.add(entry.candidate_email);
                uniqueMobileNumbers.add(entry.candidate_mobile_number);
            }
        });

        if (repeatedEntries.length > 0) {
            for (var j = 0; j < repeatedEntries.length; repeatedEntries++) {
                newErrors.push(
                    {
                        uniqueId: repeatedEntries[j]['uniqueId'],
                        key: repeatedEntries[j]['key'],
                        errorMessage: `${repeatedEntries[j]['label']} is duplicate!`
                    }
                )
            }
        }

        setErrors(newErrors);

        if (newErrors.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    const uploadProfileApiCall = () => {
        if (candidateProfileData.length > 0) {
            if (validateProfileData()) {
                setIsLoading(true)
                fetch(`${API_URL}api/addCandidateProfileData`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${userDetails.token}`,
                    },
                    body: JSON.stringify({
                        candidateProfileData: candidateProfileData
                    })
                })
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.success) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: response.message, life: 3000 });
                            setShowUploadProfiles(false);
                            setCandidateProfileData([]);
                            setTimeout(() => {
                                navigate(`/job/${jobDetails._id}/scheduled-profile`)
                            }, 2000)
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: response.message, life: 3000 });
                        }
                        setIsLoading(false)
                    })
                    .catch((err) => {
                        setIsLoading(false)
                        console.log("error", err);
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    });
            }
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please upload records first', life: 3000 });
        }
    }

    const [editConfirmHeaderText, setEditConfirmHeaderText] = useState("");
    const [editConfirmDialogShow, setEditConfirmDialogShow] = useState(false);

    const editConfirmModalFooterContent = (
        <div>
            <Button variant="primary" onClick={() => setEditConfirmDialogShow(false)} >Ok</Button>
        </div>
    );

    const clearFilter = () => {
        const clearedFilters = {
            companyId: null,
            employerSuperAdminId: null,
            employerSubAdminId: null
        };
        setSelectedFields(clearedFilters);
        setCompanyUsers([]);
        sessionStorage.removeItem('dashboardFilters');

        // Reset pagination to fetch all data without filters
        resetPagination();
    }

    const filterOnChange = (e) => {
        const { name, value } = e.target

        // console.log('Filter change:', name, value, 'Current state:', selectedFields);

        setSelectedFields(prevFields => {
            const newFields = { ...prevFields };

            if (name === "companyId") {
                if (value) {
                    getCompanyUsers(value)
                    newFields[name] = value;
                } else {
                    setCompanyUsers([])
                    newFields[name] = value;
                    newFields.employerSuperAdminId = null;
                    newFields.employerSubAdminId = null;
                }
            } else if (name === "employerSuperAdminId") {
                // For employer super admin, just update this field only
                newFields[name] = value;
                // console.log('Setting employer super admin:', value);
            } else if (name === "employerSubAdminId") {
                // For employer sub admin, just update this field only
                newFields[name] = value;
                // console.log('Setting employer sub admin:', value);
            }

            // console.log('New state will be:', newFields);
            return newFields;
        });
    }

    const getCompanyUsers = (companyId) => {
        fetch(`${API_URL}api/getUsers?sortBy=first_name&sortOrder=asc`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userDetails.token}`,
            },
            body: JSON.stringify({
                company_id: companyId
            })
        })
            .then((response) => response.json())
            .then((response) => {
                if (!_.isUndefined(response) && !_.isNull(response) && !_.isUndefined(response.data) && !_.isNull(response.data) && !_.isEmpty(response.data) && (response.data.length > 0)) {
                    setCompanyUsers(response.data)
                } else {
                    setCompanyUsers([])
                }
            })
            .catch((err) => {
                setCompanyUsers([]);
            });
    }

    // Instead, add a separate function to apply filters
    const applyFilters = () => {
        resetPagination();
    }

    // Update the ref whenever selectedFields changes
    useEffect(() => {
        selectedFieldsRef.current = selectedFields;
    }, [selectedFields]);

    const hasActiveFilters = () => {
        return Object.values(selectedFields).some(value => value !== null && value !== '');
    };

    const refreshRecords = async () => {
        setIsRefreshing(true);
        try {
            const response = await fetch(`${API_URL}api/recordings`);
            const data = await response.json();
            console.log("data=>", data);
            toast.current.show({ severity: 'success', summary: 'Success', detail: data.message || 'Records refreshed!', life: 3000 });
            setIsRefreshing(false);
        } catch (error) {
            console.log("Error=>", error);
            setIsRefreshing(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to refresh records', life: 3000 });
        }
    }

    return (
        <Fragment>
            <Toast ref={toast} />
            {
                isLoading &&
                <div className="spinner-loader">
                    <Loader type="spinner-circle" bgColor="#2F2F74" color="#2F2F74" size={100} />
                </div>
            }
            {
                profileIsLoading &&
                <div className="spinner-loader">
                    <Loader type="spinner-circle" bgColor="#2F2F74" color="#2F2F74" size={100} />
                </div>
            }
            <div className="container-fluid employer-dashboard-container fixed-padding">
                <div className="row">
                    <div className="col-12 px-0">
                        <HeaderScreen />
                    </div>
                </div>
                <div class="row mx-1"><div class="col-12 dashboard-title pageTitle_fixed"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" aria-hidden="true" class="header-icon" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>DASHBOARD</div></div>
                <div className="pageTitle_fixed brd-0">
                    <div className="col-12 d-flex align-items-center justify-content-between">
                        <p className="employer-dashboard-jobs-posted mb-0">
                            <div className='d-flex align-items-center gap-2'><HiChartPie size={18} />Jobs posted</div>
                        </p>
                        {[SUPER_ADMIN, SUB_ADMIN].includes(userDetails.account_type) &&
                            <span className='px-3'>
                                <Button style={{
                                    marginTop: '0px',
                                    background: '#FFFBFE',
                                    color: 'black',
                                    // border: 'none'
                                }}
                                    disabled={isRefreshing}
                                    className="employer-dashboard-interview-join"
                                    onClick={refreshRecords}
                                >{isRefreshing ? 'Refreshing...' : 'Refresh Interview Records'}</Button>
                            </span>
                        }
                    </div>
                </div>
                <div className="row job-container">
                    <div className="col-12 employer-dashboard-title dashboard-jobs ">

                        {
                            (userDetails.account_type === SUPER_ADMIN || (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "")) && (
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip>Statistics</Tooltip>}
                                >
                                    <div className="bar-dashboard" >
                                        <Link to={{
                                            pathname: "/state"
                                        }} style={{ color: 'white' }}>
                                            <FontAwesomeIcon icon={faBars} />
                                        </Link>
                                    </div>
                                </OverlayTrigger>
                            )
                        }

                        <div className="report-filter-section job-filter repos" style={{ width: '50px' }}>
                            {
                                (userDetails.account_type === SUPER_ADMIN || userDetails.account_type === SUB_ADMIN || (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "")) && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Filters</Tooltip>}
                                    >
                                        <DropdownButton
                                            id="report-filter"
                                            title={<CiFilter style={{ width: '25px', height: '25px' }} />}
                                            style={{
                                                backgroundImage: 'none',
                                                backgroundColor: hasActiveFilters() ? '#007bff' : 'transparent',
                                                borderColor: hasActiveFilters() ? '#007bff' : undefined,
                                                color: hasActiveFilters() ? 'white' : undefined
                                            }}
                                        >
                                            <div className="px-2 pb-2 pt-3">
                                                {
                                                    userDetails && (userDetails.account_type === SUPER_ADMIN || userDetails.account_type === SUB_ADMIN) && (
                                                        <Form.Select value={selectedFields.companyId ?? ""} name="companyId" onChange={filterOnChange} aria-label="Default select example">
                                                            <option value="">Select Company</option>
                                                            {companyList && companyList.map((item, index) => (
                                                                <option value={item.id} className="filter-item">{item.company_name}</option>
                                                            ))}
                                                        </Form.Select>
                                                    )
                                                }
                                            </div>
                                            <div className="px-2 py-2">
                                                {
                                                    userDetails && (userDetails.account_type === SUPER_ADMIN || userDetails.account_type === SUB_ADMIN || (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "")) && (
                                                        <Form.Select value={selectedFields.employerSuperAdminId ?? ""} name="employerSuperAdminId" onChange={filterOnChange} aria-label="Default select example">
                                                            <option value="">Select Employer Super Admin</option>
                                                            {companyUsers && companyUsers
                                                                .filter((item) => item.account_type === EMPLOYER_SUPER_ADMIN)
                                                                .map((item, index) => (
                                                                    <option key={index} value={item.id} className="filter-item">
                                                                        {`${item.first_name} ${item.last_name}`}
                                                                    </option>
                                                                ))}
                                                        </Form.Select>
                                                    )
                                                }
                                            </div>
                                            <div className="px-2 py-2">
                                                {
                                                    userDetails && (userDetails.account_type === SUPER_ADMIN || userDetails.account_type === SUB_ADMIN || (userDetails.account_type === EMPLOYER_SUPER_ADMIN && userDetails.company_id === "")) && (
                                                        <Form.Select value={selectedFields.employerSubAdminId ?? ""} name="employerSubAdminId" onChange={filterOnChange} aria-label="Default select example">
                                                            <option value="">Select Employer Sub Admin</option>
                                                            {companyUsers && companyUsers
                                                                .filter((item) => item.account_type === EMPLOYER_SUB_ADMIN)
                                                                .map((item, index) => (
                                                                    <option key={index} value={item.id} className="filter-item">
                                                                        {`${item.first_name} ${item.last_name}`}
                                                                    </option>
                                                                ))}
                                                        </Form.Select>
                                                    )
                                                }
                                            </div>
                                            <div className="my-2" style={{ textAlign: 'center' }}>
                                                <Button onClick={clearFilter} style={{
                                                    marginTop: '0px',
                                                    background: '#FFFBFE',
                                                    color: 'black',
                                                    border: 'none'
                                                }} className="employer-dashboard-interview-join">
                                                    Reset
                                                </Button>
                                            </div>
                                        </DropdownButton>
                                    </OverlayTrigger>
                                )
                            }
                        </div>

                        <Tab.Container defaultActiveKey="openJobs">

                            {
                                (userDetails.account_type === SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) && (
                                    <div className="row">
                                        <div className="col-12">
                                            <Nav fill variant="tabs">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="openJobs">Open Jobs <span className='open-job'>{openJobCount}</span></Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="closedJobs">Closed Jobs <span className='closed-job'>{closedJobCount}</span></Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="jobsOnHold">Jobs On-hold <span className='onHold-job'>{onHoldJobCount}</span></Nav.Link>
                                                </Nav.Item>
                                                {/* <Nav.Item>
                                                    <Nav.Link eventKey="allJobsPosting">All Jobs Posting <span className='list-job'>{allJobCount}</span></Nav.Link>
                                                </Nav.Item> */}
                                                {
                                                    (
                                                        (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) && (
                                                            <Nav.Item>
                                                                <NavLink className="nav-link" to="/create-job">
                                                                    Create a new job
                                                                </NavLink>
                                                            </Nav.Item>
                                                        )
                                                    )
                                                }
                                            </Nav>
                                        </div>
                                    </div>
                                )
                            }

                            <div className="row">
                                <div className="col-12">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="openJobs">
                                            {
                                                !_.isUndefined(openJobList) && !_.isNull(openJobList) && openJobList.length == 0 && (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) && (<Card className="employer-dashboard-interview" >
                                                    <Card.Body>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                                                            <div className="text-center fs-6">
                                                                <p>NO JOBS CREATED &nbsp;
                                                                    <Link className="text-primary text-decoration-none" to="/create-job">CREATED A NEW JOB</Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>)
                                            }
                                            {
                                                !_.isUndefined(openJobList) && !_.isNull(openJobList) &&
                                                _.map(openJobList, (job, index) => {
                                                    return <Card className="employer-dashboard-interview" key={"employer-dashboard-interview-openJobs-" + index}>
                                                        <Card.Body className='pt-5 pt-lg-4'>
                                                            <div className="row">
                                                                <div className="col-12 col-md-12 col-lg-7" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <div className="row">
                                                                        <div className="col-12 col-md-12 col-lg-7">
                                                                            <p className="employer-dashboard-interview-job-title">Job Title &nbsp; <span>{job.job_title}</span></p>
                                                                        </div>
                                                                        <div className="col-12 col-md-12 col-lg-5">
                                                                            <p className="employer-dashboard-interview-job-title">Exp &nbsp; <span>{job.experience_min_year}-{job.experience_max_year} Years</span></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-5 text-end jd_sche">
                                                                    <Button className="employer-dashboard-interview-join" onClick={() => openJDModal(job)}>
                                                                        <IoDocumentTextOutline size={16} /><span>JD</span>
                                                                    </Button>
                                                                    {
                                                                        // job.status === JOB_STATUS_OPEN && 
                                                                        (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) ? (
                                                                            <>
                                                                                <Button className="employer-dashboard-interview-join"
                                                                                    onClick={() => { setCandidateProfileData([]); setJobDetails(job); setUploadedCandidateBulkFileName(null); setUploadedCandidateCSVFileName(null); setShowUploadProfiles(true) }}
                                                                                >
                                                                                    <BsFillCalendarWeekFill size={16} /><span>
                                                                                        Upload profiles
                                                                                    </span>
                                                                                </Button>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <Button className="employer-dashboard-interview-join"
                                                                                    onClick={() => job.status == JOB_STATUS_OPEN && navigate("/job/" + job._id + "/scheduled-profile")}
                                                                                >
                                                                                    <BsFillCalendarWeekFill size={16} /><span>Schedule profiles</span>
                                                                                </Button>
                                                                            </>
                                                                        )
                                                                    }
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        overlay={<Tooltip>Actions</Tooltip>}
                                                                    >
                                                                        <NavDropdown className="employer-dashboard-interview-action" title={<SlOptionsVertical size={20} className="employer-dashboard-interview-action-icon" />}>
                                                                            {
                                                                                (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (
                                                                                    userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id
                                                                                )) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => navigate(`/edit-job/${job._id}`)} > <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }
                                                                            {
                                                                                userDetails.account_type === EMPLOYER_SUPER_ADMIN && (
                                                                                    <>

                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_CLOSED, "Close the Job?")} > <IoIosCloseCircle size={20} /> Close job</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_ON_HOLD, "Put the Job on-hold?")} > <IoPauseOutline size={20} /> On hold</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }
                                                                            <NavDropdown.Item onClick={() => navigate("/job/" + job._id + "/report")} > <MdReport size={20} /> Report</NavDropdown.Item>
                                                                        </NavDropdown>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Created by &nbsp; <span>{job.job_created_by_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Company &nbsp; <span>{job.company_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 col-lg-5 col-12" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <p className="employer-dashboard-interview-job-title">BU / PO code &nbsp; <span>{job.bu_code}</span></p>
                                                                </div>
                                                                <div className="col-md-12 col-lg-7 col-12" style={{
                                                                    marginTop: '-8px'
                                                                }}>
                                                                    <div className="row">
                                                                        <div className="col-md-5 col-12 request-for-interviewer">
                                                                            {/* <Button onClick={() => job.status == JOB_STATUS_OPEN && (
                                                                                (userDetails.account_type == EMPLOYER_SUPER_ADMIN || userDetails.account_type == EMPLOYER_SUB_ADMIN) ? job.proposedInterviews.length > 0 : true) && navigate("/job/" + job._id + "/proposed-interviewers")} variant="outline-primary">
                                                                                <SlUser size={16} className='me-2' /><span>Request for interviewer</span>
                                                                            </Button> */}
                                                                        </div>
                                                                        <div className="col-md-5 col-12 text-center my-auto timestamp">
                                                                            <p className="employer-dashboard-interview-time">Created on {commonDateFormat(job.createdAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified on {commonDateFormat(job.updatedAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified By {job.job_modified_by_name}</p>
                                                                        </div>
                                                                        <div className="col-md-2 col-12 text-center my-auto">
                                                                            <p className="employer-dashboard-interview-today">{job.status}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                })
                                            }
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="closedJobs">
                                            {
                                                !_.isUndefined(closedJobList) && !_.isNull(closedJobList) &&
                                                _.map(closedJobList, (job, index) => {
                                                    return <Card className="employer-dashboard-interview" key={"employer-dashboard-interview-closeJobs-" + index}>
                                                        <Card.Body className='pt-5 pt-lg-4'>
                                                            <div className="row">
                                                                <div className="col-12 col-md-12 col-lg-7" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <div className="row">
                                                                        <div className="col-12 col-md-12 col-lg-7">
                                                                            <p className="employer-dashboard-interview-job-title">Job Title &nbsp; <span>{job.job_title}</span></p>
                                                                        </div>
                                                                        <div className="col-12 col-md-12 col-lg-5">
                                                                            <p className="employer-dashboard-interview-job-title">Exp &nbsp; <span>{job.experience_min_year}-{job.experience_max_year} Years</span></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-5 text-end jd_sche">
                                                                    <Button className="employer-dashboard-interview-join" onClick={() => openJDModal(job)}>
                                                                        <IoDocumentTextOutline size={16} /><span>JD</span>
                                                                    </Button>
                                                                    <Button className="employer-dashboard-interview-join button-disable"
                                                                        onClick={() => job.status == JOB_STATUS_OPEN && navigate("/job/" + job._id + "/scheduled-profile")}
                                                                    >
                                                                        <BsFillCalendarWeekFill size={16} /><span>
                                                                            {
                                                                                (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) ? "Upload profiles" : "Schedule profiles"
                                                                            }
                                                                        </span>
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        overlay={<Tooltip>Action</Tooltip>}
                                                                    >
                                                                        <NavDropdown className="employer-dashboard-interview-action" title={<SlOptionsVertical size={20} className="employer-dashboard-interview-action-icon" />}>
                                                                            {
                                                                                (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (
                                                                                    userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id
                                                                                )) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => {
                                                                                            setEditConfirmHeaderText("You can not edit close job!");
                                                                                            setEditConfirmDialogShow(true);
                                                                                        }} > <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openDeleteJobModal(job._id)} > <IoMdTrash size={20} /> Delete job</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }
                                                                            <NavDropdown.Item onClick={() => navigate("/job/" + job._id + "/report")}> <MdReport size={20} /> Report</NavDropdown.Item>
                                                                        </NavDropdown>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Created by &nbsp; <span>{job.job_created_by_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Company &nbsp; <span>{job.company_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 col-lg-5 col-12" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <p className="employer-dashboard-interview-job-title">BU / PO code &nbsp; <span>{job.bu_code}</span></p>
                                                                </div>
                                                                <div className="col-md-12 col-lg-7 col-12" style={{
                                                                    marginTop: '-8px'
                                                                }}>
                                                                    <div className="row">
                                                                        <div className="col-md-5 col-12 request-for-interviewer">
                                                                            {/* <Button onClick={() => job.status == JOB_STATUS_OPEN && job.proposedInterviews.length > 0 && navigate("/job/" + job._id + "/proposed-interviewers")} variant="outline-primary" disabled >
                                                                                <SlUser size={16} className='me-2' /><span>Request for interviewer</span>
                                                                            </Button> */}
                                                                        </div>
                                                                        <div className="col-md-5 col-12 text-center my-auto timestamp">
                                                                            <p className="employer-dashboard-interview-time">Created on {commonDateFormat(job.createdAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified on {commonDateFormat(job.updatedAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified By {job.job_modified_by_name}</p>
                                                                        </div>
                                                                        <div className="col-md-2 col-12 text-center my-auto">
                                                                            <p className="employer-dashboard-interview-today button-disable closed-job">{job.status}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                })
                                            }
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="jobsOnHold">
                                            {
                                                !_.isUndefined(onHoldJobList) && !_.isNull(onHoldJobList) &&
                                                _.map(onHoldJobList, (job, index) => {
                                                    return <Card className="employer-dashboard-interview" key={"employer-dashboard-interview-jobOnHold-" + index}>
                                                        <Card.Body className='pt-5 pt-lg-4'>
                                                            <div className="row">
                                                                <div className="col-12 col-md-12 col-lg-7" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <div className="row">
                                                                        <div className="col-12 col-md-12 col-lg-7">
                                                                            <p className="employer-dashboard-interview-job-title">Job Title &nbsp; <span>{job.job_title}</span></p>
                                                                        </div>
                                                                        <div className="col-12 col-md-12 col-lg-5">
                                                                            <p className="employer-dashboard-interview-job-title">Exp &nbsp; <span>{job.experience_min_year}-{job.experience_max_year} Years</span></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-5 text-end jd_sche">
                                                                    <Button className="employer-dashboard-interview-join" onClick={() => openJDModal(job)}>
                                                                        <IoDocumentTextOutline size={16} /><span>JD</span>
                                                                    </Button>
                                                                    <Button className="employer-dashboard-interview-join button-disable"
                                                                        onClick={() => job.status == JOB_STATUS_OPEN && navigate("/job/" + job._id + "/scheduled-profile")}
                                                                    >
                                                                        <BsFillCalendarWeekFill size={16} /><span>
                                                                            {
                                                                                (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) ? "Upload profiles" : "Schedule profiles"
                                                                            }
                                                                        </span>
                                                                    </Button>
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        overlay={<Tooltip>Action</Tooltip>}
                                                                    >
                                                                        <NavDropdown className="employer-dashboard-interview-action" title={<SlOptionsVertical size={20} className="employer-dashboard-interview-action-icon" />}>
                                                                            {
                                                                                userDetails.account_type === EMPLOYER_SUPER_ADMIN && (
                                                                                    <>

                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_CLOSED, "Close the Job?")} > <IoIosCloseCircle size={20} /> Close job</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_OPEN, "Reopen Job?")} > <IoPauseOutline size={20} /> Reopen</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }
                                                                            {
                                                                                (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (
                                                                                    userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id
                                                                                )) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => {
                                                                                            setEditConfirmHeaderText("You can not edit this job Reopen the job to edit");
                                                                                            setEditConfirmDialogShow(true);
                                                                                        }} > <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }
                                                                            <NavDropdown.Item onClick={() => navigate("/job/" + job._id + "/report")}> <MdReport size={20} /> Report</NavDropdown.Item>

                                                                        </NavDropdown>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Created by &nbsp; <span>{job.job_created_by_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Company &nbsp; <span>{job.company_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 col-lg-5 col-12" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <p className="employer-dashboard-interview-job-title">BU / PO code &nbsp; <span>{job.bu_code}</span></p>
                                                                </div>
                                                                <div className="col-md-12 col-lg-7 col-12" style={{
                                                                    marginTop: '-8px'
                                                                }}>
                                                                    <div className="row">
                                                                        <div className="col-md-5 col-12 request-for-interviewer">
                                                                            {/* <Button onClick={() => job.status == JOB_STATUS_OPEN && (
                                                                                (userDetails.account_type == EMPLOYER_SUPER_ADMIN || userDetails.account_type == EMPLOYER_SUB_ADMIN) ? job.proposedInterviews.length > 0 : true) && navigate("/job/" + job._id + "/proposed-interviewers")} className={`employer-dashboard-interview-contact alljob ${job.status != JOB_STATUS_OPEN ? 'button-disable' : ''}`}>
                                                                                <SlUser size={16} variant="outline-primary" /><span>Request for interviewer</span>
                                                                            </Button> */}
                                                                        </div>
                                                                        <div className="col-md-5 col-12 text-center my-auto timestamp">
                                                                            <p className="employer-dashboard-interview-time">Created on {commonDateFormat(job.createdAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified on {commonDateFormat(job.updatedAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified By {job.job_modified_by_name}</p>
                                                                        </div>
                                                                        <div className="col-md-2 col-12 text-center my-auto">
                                                                            <p className={` ${job.status == JOB_STATUS_OPEN ? 'employer-dashboard-interview-today' : (job.status == JOB_STATUS_ON_HOLD ? 'employer-dashboard-interview-on-hold holdjob' : 'employer-dashboard-interview-closed closed-job')}`}>{job.status}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                })
                                            }
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="allJobsPosting">
                                            {
                                                !_.isUndefined(jobList) && !_.isNull(jobList) &&
                                                _.map(jobList, (job, index) => {
                                                    return <Card className="employer-dashboard-interview" key={"employer-dashboard-interview-allJobs-" + index}>
                                                        <Card.Body className='pt-5 pt-lg-4'>
                                                            <div className="row">
                                                                <div className="col-12 col-md-12 col-lg-7" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <div className="row">
                                                                        <div className="col-12 col-md-12 col-lg-7">
                                                                            <p className="employer-dashboard-interview-job-title">Job Title &nbsp; <span>{job.job_title}</span></p>
                                                                        </div>
                                                                        <div className="col-12 col-md-12 col-lg-5">
                                                                            <p className="employer-dashboard-interview-job-title">Exp &nbsp; <span>{job.experience_min_year}-{job.experience_max_year} Years</span></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-12 col-lg-5 text-end jd_sche">
                                                                    <Button className="employer-dashboard-interview-join" onClick={() => openJDModal(job)}>
                                                                        <IoDocumentTextOutline size={16} /><span>JD</span>
                                                                    </Button>
                                                                    {
                                                                        job.status !== JOB_STATUS_OPEN ? (
                                                                            (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) ? (
                                                                                <>
                                                                                    <Button className="employer-dashboard-interview-join"
                                                                                        onClick={() => { setCandidateProfileData([]); setJobDetails(job); setUploadedCandidateBulkFileName(null); setUploadedCandidateCSVFileName(null); setShowUploadProfiles(true) }}
                                                                                    >
                                                                                        <BsFillCalendarWeekFill size={16} /><span>
                                                                                            Upload profiles
                                                                                        </span>
                                                                                    </Button>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <Button className={job.status === JOB_STATUS_OPEN ? 'employer-dashboard-interview-join' : 'employer-dashboard-interview-join button-disable'}
                                                                                        onClick={() => job.status == JOB_STATUS_OPEN && navigate("/job/" + job._id + "/scheduled-profile")}
                                                                                    >
                                                                                        <BsFillCalendarWeekFill size={16} /><span>Schedule profiles</span>
                                                                                    </Button>
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            (userDetails.account_type === EMPLOYER_SUPER_ADMIN || userDetails.account_type === EMPLOYER_SUB_ADMIN) ? (
                                                                                <>
                                                                                    <Button className="employer-dashboard-interview-join"
                                                                                        onClick={() => { setCandidateProfileData([]); setJobDetails(job); setUploadedCandidateBulkFileName(null); setUploadedCandidateCSVFileName(null); setShowUploadProfiles(true) }}
                                                                                    >
                                                                                        <BsFillCalendarWeekFill size={16} /><span>
                                                                                            Upload profiles
                                                                                        </span>
                                                                                    </Button>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <Button className={job.status === JOB_STATUS_OPEN ? 'employer-dashboard-interview-join' : 'employer-dashboard-interview-join button-disable'}
                                                                                        onClick={() => job.status === JOB_STATUS_OPEN && navigate("/job/" + job._id + "/scheduled-profile")}
                                                                                    >
                                                                                        <BsFillCalendarWeekFill size={16} /><span>Schedule profiles</span>
                                                                                    </Button>
                                                                                </>
                                                                            )
                                                                        )
                                                                    }
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        overlay={<Tooltip>Action</Tooltip>}
                                                                    >
                                                                        <NavDropdown className="employer-dashboard-interview-action" title={<SlOptionsVertical size={20} className="employer-dashboard-interview-action-icon" />}>

                                                                            {
                                                                                job.status === JOB_STATUS_OPEN && (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id)) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => navigate(`/edit-job/${job._id}`)}> <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }

                                                                            {
                                                                                userDetails.account_type === EMPLOYER_SUPER_ADMIN && job.status === JOB_STATUS_OPEN && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_CLOSED, "Close the Job?")} > <IoIosCloseCircle size={20} /> Close job</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_ON_HOLD, "Put the Job on-hold?")} > <IoPauseOutline size={20} /> On hold</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }

                                                                            {
                                                                                job.status === JOB_STATUS_CLOSED && (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id)) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => {
                                                                                            setEditConfirmHeaderText("You can not edit close job!");
                                                                                            setEditConfirmDialogShow(true);
                                                                                        }} > <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openDeleteJobModal(job._id)} > <IoMdTrash size={20} /> Delete job</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }

                                                                            {
                                                                                userDetails.account_type === EMPLOYER_SUPER_ADMIN && job.status === JOB_STATUS_ON_HOLD && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_CLOSED, "Close the Job?")} > <IoIosCloseCircle size={20} /> Close job</NavDropdown.Item>
                                                                                        <NavDropdown.Item onClick={() => openJobStatusModal(job, JOB_STATUS_OPEN, "Reopen Job?")} > <IoPauseOutline size={20} /> Reopen</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }

                                                                            {
                                                                                job.status === JOB_STATUS_ON_HOLD && (userDetails.account_type === EMPLOYER_SUPER_ADMIN || (userDetails.account_type === EMPLOYER_SUB_ADMIN && userDetails.id === job.job_created_by_id)) && (
                                                                                    <>
                                                                                        <NavDropdown.Item onClick={() => {
                                                                                            setEditConfirmHeaderText("You can not edit this job Reopen the job to edit");
                                                                                            setEditConfirmDialogShow(true);
                                                                                        }} > <LuPencilLine size={20} /> Edit</NavDropdown.Item>
                                                                                    </>
                                                                                )
                                                                            }

                                                                            <NavDropdown.Item onClick={() => navigate("/job/" + job._id + "/report")}> <MdReport size={20} /> Report</NavDropdown.Item>

                                                                        </NavDropdown>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Created by &nbsp; <span>{job.job_created_by_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                <div className="col-12">
                                                                    <p className="employer-dashboard-interview-job-title">Company &nbsp; <span>{job.company_name}</span></p>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 col-lg-5 col-12" style={{ cursor: 'pointer' }} onClick={() => navigate(`/job/${job._id}/scheduled-profile`)}>
                                                                    <p className="employer-dashboard-interview-job-title">BU / PO code &nbsp; <span>{job.bu_code}</span></p>
                                                                </div>
                                                                <div className="col-md-12 col-lg-7 col-12" style={{
                                                                    marginTop: '-8px'
                                                                }}>
                                                                    <div className="row">
                                                                        <div className="col-md-5 col-12 request-for-interviewer">
                                                                            {/* <Button   onClick={() => job.status == JOB_STATUS_OPEN && (
                                                                                (userDetails.account_type == EMPLOYER_SUPER_ADMIN || userDetails.account_type == EMPLOYER_SUB_ADMIN) ? job.proposedInterviews.length > 0 : true) && navigate("/job/" + job._id + "/proposed-interviewers")} className={`employer-dashboard-interview-contact alljob ${job.status != JOB_STATUS_OPEN ? 'button-disable' : ''}`}>
                                                                                <SlUser size={16} variant="outline-primary" /><span>Request for interviewer</span>
                                                                            </Button> */}
                                                                        </div>
                                                                        <div className="col-md-5 col-12 text-center my-auto timestamp">
                                                                            <p className="employer-dashboard-interview-time">Created on {commonDateFormat(job.createdAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified on {commonDateFormat(job.updatedAt)}</p>
                                                                            <p className="employer-dashboard-interview-time">Modified By {job.job_modified_by_name}</p>
                                                                        </div>
                                                                        <div className="col-md-2 col-12 text-center my-auto">
                                                                            <p className={` ${job.status == JOB_STATUS_OPEN ? 'employer-dashboard-interview-today' : (job.status == JOB_STATUS_ON_HOLD ? 'employer-dashboard-interview-on-hold holdjob' : 'employer-dashboard-interview-closed closed-job')}`}>{job.status}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                })
                                            }
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </Tab.Container>
                        {
                            allJobCount > page * limit && (
                                <div class="load-more-container text-center mt-4">
                                    <Button
                                        variant="primary"
                                        className="employer-dashboard-interview-join bounce-animation"
                                        onClick={() => {
                                            setPage(page + 1)
                                            setLimit(limit + 5)
                                            setPageTrigger((pageTrigger) => pageTrigger + 1)
                                        }}
                                    >
                                        <FaArrowCircleDown />
                                        <span>Load More</span>
                                    </Button>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            {
                showJobJD && !_.isUndefined(jobDetails) && !_.isNull(jobDetails) && !_.isUndefined(jobDetails._id) && !_.isNull(jobDetails._id) && (jobDetails._id !== '') &&
                <Modal centered show={showJobJD} onHide={() => { setShowJobJD(false) }} animation={false} size="xl">
                    <Modal.Header closeButton>

                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mt-4">
                            <div className="col-12 mb-2"><b>Job title: </b><span>{jobDetails.job_title}</span></div>
                            <div className="col-12 mb-2"><b>Primary Skill: </b><span>{jobDetails.primary_skill.join(", ")}</span></div>
                            <div className="col-12 mb-2"><b>Job created date: </b><span>{commonDateFormat(jobDetails.createdAt)}</span></div>
                            <div className="col-12 mb-2"><b>Job created by: </b><span>{jobDetails.job_created_by_name}</span></div>
                            {
                                jobDetails.upload_jd && jobDetails.upload_jd.includes('.doc') ?
                                    <iframe key="iframe-doc" style={{
                                        width: '100%',
                                        height: '80vh'
                                    }} src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${jobDetails.upload_jd}`}&embedded=true`}></iframe> :
                                    // <EmbedPDF>
                                    //     <a href={`${process.env.REACT_APP_BUCKET_URL}${jobDetails.upload_jd}`}>
                                    //         Click here to open
                                    //     </a>
                                    // </EmbedPDF>
                                    <iframe title="Resume" key="iframe-doc" style={{
                                        width: '100%',
                                        height: '50vh'
                                    }} src={`https://docs.google.com/gview?url=${`${process.env.REACT_APP_BUCKET_URL}${jobDetails.upload_jd}`}&embedded=true`}></iframe>
                            }
                        </div>
                    </Modal.Body>
                </Modal>
            }
            {/* Edit job confirm Dialog */}
            <Dialog header={editConfirmHeaderText} visible={editConfirmDialogShow} style={{ width: '350px', textAlign: 'center' }} pt={{
                root: { className: 'dialog-root' },
                header: { className: 'dialog-header' },
                content: { className: 'dialog-content' },
                footer: { className: 'dialog-footer' },
                closeButton: { className: 'hide' }
            }} footer={editConfirmModalFooterContent} onHide={() => setEditConfirmDialogShow(false)} dismissableMask="true"></Dialog>
            {/* Status change dialog */}
            <Dialog header={dialogHeader} visible={dialogShow} style={{ width: '350px', textAlign: 'center' }} pt={{
                root: { className: 'dialog-root' },
                header: { className: 'dialog-header' },
                content: { className: 'dialog-content' },
                footer: { className: 'dialog-footer' },
                closeButton: { className: 'hide' }
            }} footer={statusChangeModalfooterContent} onHide={() => setDialogShow(false)} dismissableMask="true">
            </Dialog>
            {/* delete job dialog */}
            <Dialog header="Do you want to delete the job?" visible={deleteJobModal} style={{ width: '350px', textAlign: 'center' }} pt={{
                root: { className: 'dialog-root' },
                header: { className: 'dialog-header' },
                content: { className: 'dialog-content' },
                footer: { className: 'dialog-footer' },
                closeButton: { className: 'hide' }
            }} footer={deleteJobModalfooterContent} onHide={() => closeDeleteJobModal()} dismissableMask="true">
            </Dialog>
            {
                showUploadProfiles && !_.isUndefined(jobDetails) && !_.isNull(jobDetails) && !_.isUndefined(jobDetails._id) && !_.isNull(jobDetails._id) && (jobDetails._id !== '')
                &&
                <Dialog
                    header={`Upload Profiles for "${jobDetails.job_title}"`}
                    visible={showUploadProfiles}
                    style={{ width: '90vw' }}
                    footer={uploadProfileModalFooterContent}
                    onHide={() => setShowUploadProfiles(false)}
                    dismissableMask={true}
                >
                    <div className="row mt-4">
                        <div className="col-12 my-2 my-md-0 col-md-12 col-lg-6 col-xl-6">
                            <div className="row">
                                <div className="col-12 mb-2"><small>Job title: </small><span><span className='fs-5 fw-bold'>{jobDetails.job_title}</span></span></div>
                                <div className="col-12 mb-2"><small>Primary Skill: </small><span className='fs-5 fw-bold mx-2'>{jobDetails.primary_skill.length > 0 ? jobDetails.primary_skill.join(', ') : ''}</span></div>
                                <div className="col-12 mb-2"><small>Job created date: </small><span className='fs-5 fw-bold'>{commonDateFormat(jobDetails.createdAt)}</span></div>
                                <div className="col-12 mb-2"><small>Job created by: </small><span className='fs-5 fw-bold'>{jobDetails.job_created_by_name}</span></div>
                            </div>
                        </div>
                        <div className="col-12 my-2 my-md-0 col-md-12 col-lg-6 col-xl-6">
                            <div className='upload-profile-resume-cv'>
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                        <input style={{ display: 'none' }} type="file" name="upload_profile" onChange={uploadFiles} multiple ref={browserResumesFileRef} accept={allowedResumeTypes.join(',')} />
                                        <div className="file-upload-container mt-2" onClick={() => browserResumesFileRef.current.click()}>
                                            <div className="custom-file-upload">
                                                Choose file
                                            </div>
                                            <div className="file-name">{uploadedCandidateBulkFileName ?? "No file chosen"}</div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                                        <input style={{ display: 'none' }} type="file" name="upload_csv" onChange={uploadCSV} accept=".csv" ref={browserCSVFileRef} />
                                        <div className="file-upload-container mt-2" onClick={() => browserCSVFileRef.current.click()}>
                                            <div className="custom-file-upload">
                                                Choose file
                                            </div>
                                            <div className="file-name">{uploadedCandidateCSVFileName ?? "No file chosen"}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-6">
                                        <small style={{ fontSize: '12px' }}>*Maximum 25 profile can be uploaded at once</small>
                                    </div>
                                    <div className="col-6">
                                        <small style={{ fontSize: '12px' }}>*Upload CSV in a specific format <a href={Sample_CSV_format} download>Sample CSV format</a></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="table table-bordered table-hover mt-4">
                        <thead className="thead-light">
                            <tr>
                                <th>Candidate Name</th>
                                <th>Phone Number</th>
                                <th>Email Address</th>
                                <th>Available On</th>
                                <th>Resume</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(candidateProfileData, (candidate, index) => (
                                <tr key={"candidateProfileData_" + index}>
                                    <td>
                                        <InputText
                                            style={{ width: '100%' }}
                                            name="candidate_name"
                                            value={candidate.candidate_name}
                                            placeholder="Candidate Name"
                                            onChange={(event) => profileChangeHandler(index, event)}
                                            maxLength={50}
                                            autoComplete="off"
                                            keyfilter={/^[A-Za-z\s]*$/}
                                        />
                                        {getProfileErrorMessage(candidate.uniqueId, 'candidate_name') &&
                                            <Alert variant="danger" className="mt-2">
                                                <small>{getProfileErrorMessage(candidate.uniqueId, 'candidate_name')}</small>
                                            </Alert>}
                                    </td>

                                    <td>
                                        <InputText
                                            style={{ width: '100%' }}
                                            name="candidate_mobile_number"
                                            value={candidate.candidate_mobile_number}
                                            placeholder="Mobile Number"
                                            onChange={(event) => profileChangeHandler(index, event)}
                                            minLength={10}
                                            maxLength={10}
                                            autoComplete="off"
                                            keyfilter="int"
                                        />
                                        {getProfileErrorMessage(candidate.uniqueId, 'candidate_mobile_number') &&
                                            <Alert variant="danger" className="mt-2">
                                                <small>{getProfileErrorMessage(candidate.uniqueId, 'candidate_mobile_number')}</small>
                                            </Alert>}
                                    </td>

                                    <td>
                                        <InputText
                                            style={{ width: '100%' }}
                                            name="candidate_email"
                                            value={candidate.candidate_email}
                                            placeholder="Email Address"
                                            onChange={(event) => profileChangeHandler(index, event)}
                                            maxLength={50}
                                            autoComplete="off"
                                        />
                                        {getProfileErrorMessage(candidate.uniqueId, 'candidate_email') &&
                                            <Alert variant="danger" className="mt-2">
                                                <small>{getProfileErrorMessage(candidate.uniqueId, 'candidate_email')}</small>
                                            </Alert>}
                                    </td>

                                    <td>
                                        <DatePicker
                                            className="form-control"
                                            placeholderText="dd/MM/yyyy hh:mm a"
                                            showTimeSelect
                                            selected={candidate.available_on ? new Date(candidate.available_on) : new Date()}
                                            minDate={new Date()}
                                            dateFormat="dd/MM/yyyy hh:mm a"
                                            onChange={(date) => changeDateHandler(index, date)}
                                        />
                                        {getProfileErrorMessage(candidate.uniqueId, 'available_on') &&
                                            <Alert variant="danger" className="mt-2">
                                                <small>{getProfileErrorMessage(candidate.uniqueId, 'available_on')}</small>
                                            </Alert>}
                                    </td>

                                    <td>
                                        {candidate.resume === "" ? (
                                            <FileUpload
                                                mode="basic"
                                                chooseLabel="Upload Resume"
                                                name="resume"
                                                accept={allowedResumeTypes.join(',')}
                                                maxFileSize={1000000}
                                                customUpload
                                                onSelect={(event) => uploadResumeHandler(index, event)}
                                            />
                                        ) : (
                                            <div>
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Candidate Resume</Tooltip>}>
                                                    <a target="_blank" href={`${process.env.REACT_APP_BUCKET_URL}${candidate.resume}`} download>
                                                        <i className="pi pi-download" style={{ cursor: 'pointer', color: 'blue' }} />
                                                    </a>
                                                </OverlayTrigger>
                                                &nbsp;&nbsp;
                                                <OverlayTrigger placement="top" overlay={<Tooltip>Remove Resume</Tooltip>}>
                                                    <button className='btn' onClick={() => {
                                                        let newData = [...candidateProfileData];
                                                        newData[index].resume = "";
                                                        setCandidateProfileData(newData);
                                                    }}>
                                                        <IoClose style={{ cursor: 'pointer', color: 'red' }} size={30} />
                                                    </button>
                                                </OverlayTrigger>
                                            </div>
                                        )}
                                        {getProfileErrorMessage(candidate.uniqueId, 'resume') &&
                                            <Alert variant="danger" className="mt-2">
                                                <small>{getProfileErrorMessage(candidate.uniqueId, 'resume')}</small>
                                            </Alert>}
                                    </td>

                                    <td className="text-center">
                                        <OverlayTrigger placement="top" overlay={<Tooltip>Remove Profile</Tooltip>}>
                                            <div style={{
                                                background: '#f3ebe9',
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: 'auto'
                                            }}>
                                                <i
                                                    className="pi pi-times"
                                                    style={{ cursor: 'pointer', fontSize: '1.3rem' }}
                                                    onClick={() => removeCandidateProfile(index)}
                                                ></i>
                                            </div>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </Dialog>
            }
        </Fragment>
    )
}
export default DashboardScreen;